var map = {
	"./title-about.de-CH.json": 1501,
	"./title-about.de-DE.json": 1502,
	"./title-about.en-CA.json": 1503,
	"./title-about.en-GB.json": 1504,
	"./title-about.en-IN.json": 1505,
	"./title-about.en-ME.json": 1506,
	"./title-about.en-US.json": 1507,
	"./title-about.es-EM.json": 1508,
	"./title-about.es-ES.json": 1509,
	"./title-about.fr-BE.json": 1510,
	"./title-about.fr-CA.json": 1511,
	"./title-about.fr-CH.json": 1512,
	"./title-about.nl-BE.json": 1513,
	"./title-about.nl-NL.json": 1514,
	"./title-about.pl-PL.json": 1515,
	"./title-about.pt-BR.json": 1516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1500;